export default "__VITE_ASSET__BSeAuLx3__"